const magicClipboard = {
  namespaced: true,
  modules: {},
  state: () => ({
    clipboard: {
      text: null,
      type: 'block',
      blockData: {
        blockIds: [],
        parent: null,
        contents: []
      },
      clipData: {
        resourceId: null,
        clipId: null
      }
    }
  }),
  mutations: {
    setClipboard(state, value) {
      state.clipboard = value;
    },
    resetClipboard(state) {
      state.clipboard = {
        text: null,
        type: 'block',
        blockData: {
          blockIds: [],
          parent: null,
          contents: []
        },
        clipData: {
          resourceId: null,
          clipId: null
        }
      };
    }
  },
  actions: {}
};

export default magicClipboard;
